export const cities = [
  'Hyderabad',
  'Visakhapatnam',
  'Vijayawada',
  'Guntur',
  'Nellore',
  'Tirupati',
  'Itanagar',
  'Tawang',
  'Bhismaknagar',
  'Pasighat',
  'Ziro',
  'Bomdila',
  'Dispur',
  'Guwahati',
  'Tezpur',
  'Dibrugarh',
  'Silchar',
  'North Lakhimpur',
  'Patna',
  'Gaya',
  'Biharsharif',
  'Darbhanga',
  'Bhagalpur',
  'Raipur',
  'Bilaspur',
  'Korba',
  'Durg-Bhilainagar',
  'Raigarh',
  'Rajnandgaon',
  'Panaji',
  'Vasco-da-Gama',
  'Ponda',
  'Margao',
  'Mapusa',
  'Goa Velha',
  'Gandhinagar',
  'Ahmedabad',
  'Surat',
  'Rajkot',
  'Junagadh',
  'Vadodara',
  'Chandigarh',
  'Faridabad',
  'Gurgaon',
  'Sonipat',
  'Panipat',
  'Ambala',
  'Shimla',
  'Dharamshala',
  'Mandi',
  'Solan',
  'Bilaspur',
  'Chamba',
  'Ranchi',
  'Bokaro Steel City',
  'Jamshedpur',
  'Deoghar',
  'Hazaribagh',
  'Dhanbad',
  'Bengaluru',
  'Mysore',
  'Davangere',
  'Mangalore',
  'Hubli-Dharwad',
  'Belgaum',
  'Thiruvananthapuram',
  'Kochi',
  'Kozhikode',
  'Thrissur',
  'Malappuram',
  'Bhopal',
  'Indore',
  'Gwalior',
  'Jabalpur',
  'Ujjain',
  'Sagar',
  'Mumbai',
  'Pune',
  'Nagpur',
  'Nashik',
  'Aurangabad',
  'Solapur',
  'Imphal',
  'Bishnupur',
  'Ukhrul',
  'Tamenglong',
  'Chandel',
  'Senapati',
  'Shillong',
  'Cherrapunji',
  'Tura',
  'Jowai',
  'Baghmara',
  'Nongpoh',
  'Aizawl',
  'Lunglei',
  'Serchhip',
  'Champhai',
  'Tuipang',
  'Mamit',
  'Kohima',
  'Tuensang',
  'Zunheboto',
  'Mokokchung',
  'Kiphire Sadar',
  'Phek',
  'Bhubaneswar',
  'Rourkela',
  'Cuttack',
  'Brahmapur',
  'Puri',
  'Sambalpur',
  'Chandigarh',
  'Amritsar',
  'Jalandhar',
  'Ludhiana',
  'Patiala',
  'Kapurthala',
  'Jaipur',
  'Bikaner',
  'Jaisalmer',
  'Jodhpur',
  'Udaipur',
  'Ajmer',
  'Gangtok',
  'Namchi',
  'Gyalshing',
  'Mangan',
  'Rabdentse',
  'Chennai',
  'Tiruchirappalli',
  'Madurai',
  'Erode',
  'Vellore',
  'Coimbatore',
  'Hyderabad',
  'Warangal',
  'Nizamabad',
  'Karimnagar',
  'Adilabad',
  'Khammam',
  'Agartala',
  'Amarpur',
  'Kumarghat',
  'Udaipur',
  'Gakulnagar',
  'Kunjaban',
  'Lucknow',
  'Noida',
  'Varanasi',
  'Allahabad',
  'Agra',
  'Kanpur',
  'Dehradun',
  'Haridwar',
  'Roorkee',
  'Rishikesh',
  'Kashipur',
  'Haldwani',
  'Kolkata',
  'Darjeeling',
  'Siliguri',
  'Asansol',
  'Howrah',
  'Durgapur'
];
